import React from "react";
import works1 from "../../assets/images/works1.png";
import works2 from "../../assets/images/works2.png";
import works3 from "../../assets/images/works3.png";
import works4 from "../../assets/images/works4.png";
import works5 from "../../assets/images/friendlt.png";
import { Link } from "react-router-dom";

function Works() {
  return (
    <div className="container">
      {/* How it works Section 1 */}
      <div className="row works">
        <h1 className="works__title">How it Works</h1>
        <h5 className="works__subtitle">
          Get to know how this platform works and get started as soon as you
          can.
        </h5>
      </div>
      <div className="works-section row">
        <div className="col-md-5">
          <img src={works1} className="works-section__image" alt="" />
          <div className="works-section__body">
            <p className="works-section__title">
              Create Account as an Individual or Pharmacy Stores
            </p>
            <p className="works-section__text">
              You have the option to join us as a buyer or as a seller. Everyone
              wins!
            </p>
          </div>
        </div>
        <div className="col-md-5">
          <img src={works2} className="works-section__image" alt="" />
          <div className="works-section__body">
            <p className="works-section__title">
              Help us Identify your location
            </p>
            <p className="works-section__text">
              You have the option to narrow down your search to your preferred
              location
            </p>
          </div>
        </div>
        <div className="col-md-5">
          <img src={works3} className="works-section__image" alt="" />
          <div className="works-section__body">
            <p className="works-section__title">
              Get Drugs based on your location
            </p>
            <p className="works-section__text">
              Get your drugs in a registered pharmacy stores. We don't do fake!
            </p>
          </div>
        </div>
        <div className="col-md-5">
          <img src={works4} className="works-section__image" alt="" />
          <div className="works-section__body">
            <p className="works-section__title">
              Get Notified based on individual demand.
            </p>
            <p className="works-section__text">
              You can make demands for drugs as an individual to your preferred
              pharmacy stores and they will be duly informed.
            </p>
          </div>
        </div>
      </div>
      {/* Section 2 */}
      <div className="works-section-1 row">
        <div className="col-md-6">
          <h1 className="works-section-1__title">Your Health First</h1>
          <p className="works-section-1__subtitle">
            We try all of our best to make sure we are only aligned with
            Registered and Certified pharmacy.
          </p>
          <button className="works-section-1__button">
            <Link to="/coming-soon">Learn more</Link>
          </button>
        </div>
        <div className="col-md-6">
          <img className="works-section-1__image" src={works5} alt="" />
        </div>
      </div>
    </div>
  );
}

export default Works;
